import React, { useEffect, useState } from 'react';
import NavbarLive from './NavbarLive';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';

const LiveMatchAd = () => {
    const [loader, setLoader] = useState(false);
    const [adsData, setAdsData] = useState({});
    const [updatedAds, setUpdatedAds] = useState({});

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getAllLiveMatchAd();
            if (resp?.status) {
                setAdsData(resp?.data);
                setUpdatedAds(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (key, value) => {
        setUpdatedAds((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setLoader(true);
        try {
            const resp = await Calling.editLiveMatchAd(updatedAds);
            if (resp?.status) {
                setAdsData(updatedAds);
                toast.success("Ads updated successfully!");
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2"><h1 className="text-xl sm:text-2xl font-bold">Live Call Management</h1></div>
                    <div className='bg-main-white rounded-xl shadow-md'>
                        <NavbarLive selectState={'ads'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />

                        <div className='grid grid-cols-1 gap-4 mt-4 px-4 sm:px-6'>
                            {Object.keys(adsData).map((key, index) => (
                                <div
                                    key={index}
                                    className='flex flex-col sm:flex-row items-center justify-start gap-2 sm:gap-4 p-3 shadow-md rounded-lg border border-gray-200'
                                >
                                    <label className='w-full sm:w-1/4 text-xs sm:text-sm font-semibold text-main-subfont mb-2 sm:mb-0'>
                                        {key}
                                    </label>
                                    <input
                                        type='text'
                                        value={updatedAds[key] || ''}
                                        onChange={(e) => handleChange(key, e.target.value)}
                                        className='w-full p-2 border rounded-lg text-xs sm:text-sm'
                                    />
                                </div>
                            ))}
                        </div>
                        <div className='flex justify-start p-4'>
                            <button
                                onClick={handleSave}
                                className='px-4 py-2 text-xs sm:text-sm text-main-white rounded transition-colors 
                                           bg-green-500 hover:bg-green-600 active:bg-green-700 
                                           hover:scale-105 active:scale-95'
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LiveMatchAd;